<div class="confirmation-dialog">
    <header class="dialog-header">
        <button class="close-btn" (click)="closeDialog()">&times;</button>
    </header>

    <main class="dialog-content">
        <div class="icon-container">
            @if (data.iconSrc) {
                <img [src]="data.iconSrc" class="info-icon-image" alt="" aria-hidden="true" />
            } @else {
                <div class="info-icon">i</div>
            }
        </div>
        <h2>{{ data.message }}</h2>
        <p>{{ data.subMessage }}</p>
    </main>

    <footer class="dialog-footer">
        <button class="cancel-btn" (click)="closeDialog()">{{ "no" | translate }}</button>
        <button class="confirm-btn" (click)="confirm()">{{ "yes" | translate }}</button>
    </footer>
</div>
